import { Trans } from 'react-i18next';
import { SystemIcon } from '@monorepo/nova-icons';
import {
  BannerContainer,
  BannerWrapper,
  IconWrapper,
  StyledTypography,
} from './styled';

export const WithdrawalProcessingBanner = () => {
  return (
    <BannerWrapper>
      <BannerContainer>
        <IconWrapper>
          <SystemIcon iconName="Warning" color="inherit" />
        </IconWrapper>
        <StyledTypography>
          <Trans
            i18nKey="dashboardTemplates:waiting_withdraw_banner"
            components={{ strong: <strong /> }}
          />
        </StyledTypography>
      </BannerContainer>
    </BannerWrapper>
  );
};
